import { useMemo } from 'react';

import { FiMaximize2, FiMinimize2 } from 'react-icons/fi';

import * as S from './styles';

type BroadcastStatus = 'live' | 'upcoming' | 'replay';

type BroadcastTitleProps = {
  title?: string;
  startDate?: string;
  endDate?: string;
  theaterMode?: boolean;
  onToggleTheater?: () => void;
  extra?: React.ReactNode;
};

const getBroadcastStatus = (
  startDate?: string,
  endDate?: string,
): BroadcastStatus => {
  if (!startDate || !endDate) return 'live';

  const now = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);

  if (now < start) return 'upcoming';
  if (now > end) return 'replay';
  return 'live';
};

const STATUS_CONFIG: Record<
  BroadcastStatus,
  { label: string; variant: BroadcastStatus }
> = {
  live: { label: 'AO VIVO', variant: 'live' },
  upcoming: { label: 'EM BREVE', variant: 'upcoming' },
  replay: { label: 'REPRISE', variant: 'replay' },
};

const BroadcastTitle = ({
  title = 'Transmissão',
  startDate,
  endDate,
  theaterMode = false,
  onToggleTheater,
  extra,
}: BroadcastTitleProps) => {
  const status = useMemo(
    () => getBroadcastStatus(startDate, endDate),
    [startDate, endDate],
  );

  const config = STATUS_CONFIG[status];

  return (
    <S.Container>
      <S.Left>
        <S.TitleWrapper>
          <S.Title>{title}</S.Title>
          <S.MetaInfo>
            <S.StatusIndicator $variant={config.variant}>
              {status === 'live' && <S.LiveDot />}
              <span>{config.label}</span>
            </S.StatusIndicator>
          </S.MetaInfo>
        </S.TitleWrapper>
      </S.Left>

      <S.Right>
        {extra}
        {onToggleTheater && (
          <S.TheaterButton onClick={onToggleTheater} type="button">
            {theaterMode ? (
              <FiMinimize2 size={18} />
            ) : (
              <FiMaximize2 size={18} />
            )}
            <span>{theaterMode ? 'Sair' : 'Modo Teatro'}</span>
          </S.TheaterButton>
        )}
      </S.Right>
    </S.Container>
  );
};

export default BroadcastTitle;
